import first from "lodash/first";
import { graphql } from "react-relay";
import { readInlineData } from "relay-runtime";
import { findFirstNonEmptyString } from "scmp-sdk";

import { durationToISOString, notEmpty } from "shared/lib/utils";

import type { helpersGetVideoYoutubeIdVideo$key } from "scmp-app/queries/__generated__/helpersGetVideoYoutubeIdVideo.graphql";

export const getVideoYoutubeId = (reference?: helpersGetVideoYoutubeIdVideo$key | null) => {
  const video = readInlineData(
    graphql`
      fragment helpersGetVideoYoutubeIdVideo on Video @inline {
        youtubeId
        videoSource {
          id
          type
        }
      }
    `,
    reference ?? null,
  );

  return (
    video?.youtubeId ??
    video?.videoSource?.find(source => source?.type === "youtube")?.id ??
    undefined
  );
};

type VideoDescriptionSource = {
  subHeadline?: null | string;
  summary?: null | string;
};

export const getVideoDescription = ({ subHeadline, summary }: VideoDescriptionSource) =>
  findFirstNonEmptyString(first(summary?.split("\n")), first(subHeadline?.split("\n"))) ||
  undefined;

export const parseDuration = (duration?: null | string) => {
  const parts = duration?.trim().split(":") ?? [];
  if (parts.length < 2 || parts.length > 3 || !parts.every(part => /^\d+$/.test(part))) return;
  const [seconds = 0, minutes = 0, hours = 0] = parts.map(Number).toReversed();
  if (hours * 3600 + minutes * 60 + seconds === 0) return;
  return durationToISOString({ hours, minutes, seconds });
};

export const getVideoYoutubeEmbedUrl = (youtubeId?: string) => {
  if (!notEmpty(youtubeId)) return;

  return `https://www.youtube.com/embed/${youtubeId}`;
};

export const getVideoYoutubeThumbnailUrl = (youtubeId?: string) => {
  if (!notEmpty(youtubeId)) return;

  const thumbnails = [
    `https://i.ytimg.com/vi/${youtubeId}/maxresdefault.jpg`,
    `https://i.ytimg.com/vi/${youtubeId}/hqdefault.jpg`,
    `https://i.ytimg.com/vi/${youtubeId}/mqdefault.jpg`,
    `https://i.ytimg.com/vi/${youtubeId}/sddefault.jpg`,
  ];

  return thumbnails;
};
